import produce from "immer";
import { UserData } from "core/queries/GetTeam";
import {
  ActionType,
  AddUndoAction,
  RemoveUndoAction,
  SetFiltersAction,
  UndoAction,
} from "team/actions";
import { UserFilterInput } from "typings/globalGQLTypes";

export interface UndoState {
  action: UndoAction;
  user: UserData;
}

export interface TeamState {
  filters: UserFilterInput;
  undo: UndoState | null;
}

export type AllTeamActions =
  | AddUndoAction
  | RemoveUndoAction
  | SetFiltersAction;

export const initialState: TeamState = {
  filters: {
    roles: [],
    squads: [],
    cityId: null,
    ids: null,
  },
  undo: null,
};

export const teamReducer = (state = initialState, action: AllTeamActions) =>
  produce(state, draft => {
    switch (action.type) {
      case ActionType.AddUndo: {
        draft.undo = action.payload;
        return draft;
      }

      case ActionType.RemoveUndo: {
        draft.undo = null;
        return draft;
      }

      case ActionType.SetFilters: {
        if (action.payload) {
          draft.filters = {
            ...draft.filters,
            ...action.payload,
          };
        }
        return draft;
      }

      default:
        return draft;
    }
  });
